module.exports = __webpack_public_path__ + "img/fa-solid-900.82905d8.svg";